export enum NotificationType {
    InhouseTask       =   "inhouse_task",
    PayoutStatus      =   "payout_status",
    OffersCallback    =   "offers_callback",
    OfferWall         =   "offers_callback_sdk",
    SpinTheWheel      =   "spin_the_wheel",
}